<template>
  <div class="bloodOxygen">
    <div class="back" @click="$router.go(-1)">
      <i class="el-icon-back"></i> <span>返回上一页</span>
    </div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="血氧" name="first">
        <el-table :data="tableData" :border="true">
          <el-table-column
            label="序号"
            width="80"
            align="center"
            type="index"
            prop=""
          >
          </el-table-column>
          <el-table-column label="测量时间" align="center" prop="date">
            <template slot-scope="scope" align="center">
              {{ scope.row.DayTimestamp | handtime }}
            </template>
          </el-table-column>
          <el-table-column label="设备型号" align="center" prop="DeviceType">
            <template slot-scope="scope" align="center">
              {{ scope.row.DeviceType || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="血氧" align="center" prop="OxNum">
            <template slot-scope="scope" align="center">
              {{ scope.row.OxNum || "-" }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          layout="->,total,prev, pager, next"
          :total="total"
          :current-page="page"
          @current-change="changefn"
          :page-size="size"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { handtime } from "@/utils/util";
import { requestUserBoData } from "@/api/userApi";
export default {
  name: "bloodOxygen",
  data() {
    return {
      activeName: "first",
      page: 1,
      size: 10,
      total: 1,
      tableData: [],
    };
  },
  created() {
    this.requestUserBoDatafn();
  },
  methods: {
    changefn(index) {
      this.page = index;
      this.requestUserBoDatafn();
    },
    async requestUserBoDatafn() {
      try {
        var res = await requestUserBoData({
          userId: this.$route.query.id,
          page: this.page,
          size: this.size,
        });
        this.tableData = res.data.data.result.list;
        this.total = res.data.data.result.count;
      } catch (err) {
        console.log(err);
      }
    },
  },
  filters: {
    handtime,
  },
};
</script>

<style lang="less">
.bloodOxygen {
  padding: 15px;
  position: relative;
  .back {
    position: absolute;
    right: 40px;
    top: 15px;
    height: 40px;
    line-height: 40px;
    color: #4276ff;
    z-index: 999;
    cursor: pointer;
  }
  .el-table {
    margin-bottom: 20px;
  }
  thead tr .el-table__cell {
    background-color: #e3e3e3;
    color: #333;
  }
}
</style>